module.exports = __webpack_public_path__ + "img/CargaFactura.59097108.png";